import Vue from "vue";
import Router from "vue-router";
import AuthService from "../services/AuthService";
import auth from "@/components/auth";
import login from "@/components/login";
import forgotPassword from "@/components/forgot-password";
import forgotPasswordReset from "@/components/forgot-password-reset";

import users from "@/components/users";

import dataCategories from "@/components/data/data-categories";
import sites from "@/components/data/sites";
import siteDetails from "@/components/data/site_details";
import trapSites from "@/components/data/trap_sites";
import trapSitesDetails from "@/components/data/trap_site_details";
import noSpray from "@/components/data/no_spray";
import noSprayDetails from "@/components/data/no_spray_details";
import landingRates from "@/components/data/landing_rates";
import landingRateDetails from "@/components/data/landing_rate_details";
import serviceRequests from "@/components/data/service_requests";
import serviceRequestDetails from "@/components/data/service_request_details";
import adulticide from "@/components/data/adulticide";
import adulticideDetails from "@/components/data/adulticide_details";
import arboviral from "@/components/data/arboviral";
import arboviralDetails from "@/components/data/arboviral_details";
import adultSurveillances from "@/components/data/adult_surveillances";
import adultSurveillanceDetails from "@/components/data/adult_surveillance_details";
import larvicide from "@/components/data/larvicide";
import larvicideDetails from "@/components/data/larvicide_details";
import larvalIdentifcation from "@/components/data/larval_identification";
import larvalIdentifcationDetails from "@/components/data/larval_identification_details";
import larvalSites from "@/components/data/larval_sites";
import larvalSiteDetails from "@/components/data/larval_site_details";

import lookup from "@/components/lookup/lookup";
import LookupAchemicals from "@/components/lookup/achemicals";
import LookupAdultAppRates from "@/components/lookup/adultapprates";
import LookupAequips from "@/components/lookup/aequip";
import LookupApplicators from "@/components/lookup/applicators";
import LookupAssays from "@/components/lookup/assays";
import LookupContracts from "@/components/lookup/contracts";
import LookupContractAddresses from "@/components/lookup/contract_addresses";
import LookupControlActions from "@/components/lookup/control_actions";
import LookupCounties from "@/components/lookup/counties";
import LookupHabitats from "@/components/lookup/habitats";
import LookupLarvaCounts from "@/components/lookup/larva_counts";
import LookupLarvalAppRates from "@/components/lookup/larvalapprates";
import LookupLchemicals from "@/components/lookup/lchemicals";
import LookupLequipments from "@/components/lookup/lequipments";
import LookupMixRatios from "@/components/lookup/mix_ratios";
import LookupMosquitoSpecies from "@/components/lookup/mosquito_species";
import LookupMunicipalities from "@/components/lookup/municipalities";
import LookupRequestTypes from "@/components/lookup/request_types";
import LookupResults from "@/components/lookup/results";
import LookupRoutes from "@/components/lookup/routes";
import LookupRouteSectionZones from "@/components/lookup/route_section_zones";
import LookupSraOptions from "@/components/lookup/sra_options";
import LookupStates from "@/components/lookup/states";
import LookupSubdivisions from "@/components/lookup/subdivisions";
import LookupTrapNights from "@/components/lookup/trap_nights";
import LookupTrapTeams from "@/components/lookup/trap_teams";
import LookupTrapTypes from "@/components/lookup/trap_types";
import LookupTrucks from "@/components/lookup/trucks";
import LookupVizualMonitors from "@/components/lookup/vizual_monitors";
import LookupWaters from "@/components/lookup/waters";
import LookupWindDirections from "@/components/lookup/wind_directions";
import Zones from "@/components/lookup/zones";

import report from "@/components/report/report";
import reportAdultSurveillance from "@/components/report/adult_surveillance";
import reportLarvalSurveillance from "@/components/report/larval_surveillance";
import reportLarvicideApplications from "@/components/report/larvicide_applications";
import reportArboviralSurveillance from "@/components/report/arboviral_surveillance";
import reportOTSurveillance from "@/components/report/ot_surveillance";
import reportExportTrapDates from "@/components/report/export_trap_dates";
import reportCmcWeeklyTrap from "@/components/report/cmc_weekly_trap";
import reportCmcTrapSummary from "@/components/report/cmc_trap_summary";
import reportGroundAdulticide from "@/components/report/ground_adulticide";
import reportOTWeeklyProgramSummary from "@/components/report/ot_weekly_program_summary";
import reportServiceRequestsSummary from "@/components/report/service_requests_summary";
import reportRawExport from "@/components/report/raw_export";
import reportBocoInspections from "@/components/report/boco_inspections";
import reportRouteBookSheets from "@/components/report/route_book_sheets";
import reportKillSummary from "@/components/report/kill_summary";
import reportMCSLarvicide from "@/components/report/mcs_larvicide";
import reportBocoTreatments from "@/components/report/boco_treatments";
import reportDenverLarvicideDates from "@/components/report/denver_larvicide_dates";
import reportExportLarvicideDates from "@/components/report/export_larvicide_dates";
import reportCatchBasin from "@/components/report/catch_basin";
import reportBoulderLabSubmissions from "@/components/report/boulder_lab_submissions";
import reportAdultSamplePool from "@/components/report/adult_sample_pool";
import reportArboWebSummary from "@/components/report/arbo_web_summary";
import reportExportSprayDates from "@/components/report/export_spray_dates";
import reportCallShutoff from "@/components/report/call_shutoff";
import reportServiceRequests from "@/components/report/service_requests";
import reportLandingRate from "@/components/report/landing_rate";
import reportExportNoSpray from "@/components/report/export_no_spray";
import reportCmcSeasonSummary from "@/components/report/cmc_season_summary";
import reportMosquitoSurveillanceGraph1 from "@/components/report/mosquito_surveillance_graph_1";
import reportMosquitoSurveillanceGraph2 from "@/components/report/mosquito_surveillance_graph_2";
import reportMCSNewJerseyLightTrap from "@/components/report/mcs_new_jersey_light_trap";
import reportMCSOviTrap from "@/components/report/mcs_ovi_trap";
import reportMCSGravidTrap from "@/components/report/mcs_gravid_trap";
import reportGravidHighs from "@/components/report/gravid_highs";
import reportGravidRecap from "@/components/report/gravid_recap";
import reportMCSLightFemaleTrap from "@/components/report/mcs_light_female_trap_data";
import reportOtLarvalReport from "@/components/report/ot_larval";
import reportExportHotLine from "@/components/report/export_hot_line";
import reportMCSActivityRecap from "@/components/report/mcs_activity_recap";
import reportSprayZoneRecap from "@/components/report/spray_zone_recap";

import siteAndActivityMap from "@/components/map/site-and-activity-map";
import sprayPaths from "@/views/SprayPaths";
import sprayPathsMap from "@/components/spray-paths/map-view/map-and-sidebar";

Vue.use(Router);

const router = new Router({
  linkActiveClass: "active",
  routes: [
    {
      path: "/auth",
      component: auth,
      meta: {
        auth: false,
      },
      children: [
        {
          path: "login",
          name: "login",
          component: login,
          meta: {
            title: "Login",
            auth: false,
          },
        },
        {
          path: "forgot-password",
          name: "forgot-password",
          component: forgotPassword,
          meta: {
            title: "Forgot Password",
            auth: false,
          },
        },
        {
          path: "forgot-password-reset",
          name: "forgot-password-reset",
          component: forgotPasswordReset,
          meta: {
            title: "Reset Password",
            auth: false,
          },
        },
      ],
    },
    {
      path: "/users",
      name: "users",
      component: users,
      meta: {
        title: "Users",
      },
    },
    {
      path: "/map",
      name: "site-and-activity-map",
      component: siteAndActivityMap,
      meta: {
        title: "Site & Activity Map",
      },
    },
    {
      path: "/",
      name: "spray-paths",
      component: sprayPaths,
      meta: {
        title: "Spray Paths",
      },
    },
    {
      path: "/spray-paths/map",
      name: "spray-paths-map",
      component: sprayPathsMap,
      meta: {
        title: "Spray Paths",
      },
    },
    {
      path: "/data",
      name: "data",
      component: dataCategories,
      children: [
        {
          path: "sites",
          name: "data-sites",
          component: sites,
          meta: {
            title: "Sites",
          },
        },
        {
          path: "sites/create/new",
          name: "data-sites-new",
          component: sites,
          props: true,
          meta: {
            title: "Sites",
          },
        },
        {
          path: "sites/:id",
          name: "data-site-details",
          component: siteDetails,
          props: true,
          meta: {
            title: "Sites Details",
          },
        },
        {
          path: "trap-sites",
          name: "data-trap-sites",
          component: trapSites,
          meta: {
            title: "Trap Site Master",
          },
        },
        {
          path: "trap-sites/:type/:id",
          name: "data-trap-site-with",
          component: trapSites,
          props: true,
          meta: {
            title: "Trap Site Master",
          },
        },
        {
          path: "trap-site-details/:id",
          name: "data-trap-site-details",
          component: trapSitesDetails,
          props: true,
          meta: {
            title: "Trap Site Master Details",
          },
        },
        {
          path: "no-spray",
          name: "data-no-spray",
          component: noSpray,
          meta: {
            title: "No Spray",
          },
        },
        {
          path: "no-spray/:type/:id",
          name: "data-no-spray-with",
          component: noSpray,
          props: true,
          meta: {
            title: "No Spray",
          },
        },
        {
          path: "no-spray-details/:id",
          name: "data-no-spray-details",
          component: noSprayDetails,
          props: true,
          meta: {
            title: "No Spray Details",
          },
        },
        {
          path: "landing-rates",
          name: "data-landing-rates",
          component: landingRates,
          meta: {
            title: "Landing Rates",
          },
        },
        {
          path: "landing-rates/:type/:id",
          name: "data-landing-rates-new",
          component: landingRates,
          props: true,
          meta: {
            title: "Landing Rates",
          },
        },
        {
          path: "landing-rate-details/:id",
          name: "data-landing-rate-details",
          component: landingRateDetails,
          props: true,
          meta: {
            title: "Landing Rate Details",
          },
        },
        {
          path: "service-requests",
          name: "data-service-requests",
          component: serviceRequests,
          meta: {
            title: "Service Requests",
          },
        },
        {
          path: "service-request-details/:id",
          name: "data-service-request-details",
          component: serviceRequestDetails,
          props: true,
          meta: {
            title: "Service Request Details",
          },
        },
        {
          path: "adulticide",
          name: "data-adulticide",
          component: adulticide,
          meta: {
            title: "Adulticide",
          },
        },
        {
          path: "adulticide/:type/:id",
          name: "data-adulticide-with",
          component: adulticide,
          props: true,
          meta: {
            title: "Adulticide",
          },
        },
        {
          path: "adulticide/sr/:id/c/:contractId",
          name: "data-adulticide-with-sr",
          component: adulticide,
          props: true,
          meta: {
            title: "Adulticide",
          },
        },
        {
          path: "adulticide-details/:id",
          name: "data-adulticide-details",
          component: adulticideDetails,
          props: true,
          meta: {
            title: "Adulticide Details",
          },
        },
        {
          path: "arboviral",
          name: "data-arboviral",
          component: arboviral,
          meta: {
            title: "Arboviral",
          },
        },
        {
          path: "arboviral/as/:id",
          name: "data-arboviral-details-with-as",
          component: arboviral,
          props: true,
          meta: {
            title: "Arboviral",
          },
        },
        {
          path: "arboviral-details/:id",
          name: "data-arboviral-details",
          component: arboviralDetails,
          props: true,
          meta: {
            title: "Arboviral Details",
          },
        },
        {
          path: "adult-surveillances/",
          name: "data-adult-surveillances",
          component: adultSurveillances,
          props: true,
          meta: {
            title: "Adult Surveillances",
          },
        },
        {
          path: "adult-surveillances/:type/:id",
          name: "data-adult-surveillances-with",
          component: adultSurveillances,
          props: true,
          meta: {
            title: "Adult Surveillances",
          },
        },
        {
          path: "adult-surveillance-details/:id",
          name: "data-adult-surveillance-details",
          component: adultSurveillanceDetails,
          props: true,
          meta: {
            title: "Adult Surveillance Details",
          },
        },
        {
          path: "larvicide",
          name: "data-larvicide",
          component: larvicide,
          meta: {
            title: "Larvicide",
          },
        },
        {
          path: "larvicide/:type/:id",
          name: "data-larvicide-with",
          component: larvicide,
          props: true,
          meta: {
            title: "Larvicide",
          },
        },
        {
          path: "larvicide-details/:id",
          name: "data-larvicide-details",
          component: larvicideDetails,
          props: true,
          meta: {
            title: "Larvicide Details",
          },
        },
        {
          path: "`larval`-identification",
          name: "data-larval-identification",
          component: larvalIdentifcation,
          meta: {
            title: "Larval Identification",
          },
        },
        {
          path: "larval-identification/l/:id",
          name: "data-larval-identification-with-l",
          component: larvalIdentifcation,
          props: true,
          meta: {
            title: "Larval Identification",
          },
        },
        {
          path: "larval-identification-details/:id",
          name: "data-larval-identification-details",
          component: larvalIdentifcationDetails,
          props: true,
          meta: {
            title: "Larval Identification Details",
          },
        },
        {
          path: "larval-sites",
          name: "data-larval-sites",
          component: larvalSites,
          meta: {
            title: "Larval Site Master",
          },
        },
        {
          path: "larval-site/s/:id",
          name: "data-larval-site-with-s",
          component: larvalSites,
          props: true,
          meta: {
            title: "Larval Site Master",
          },
        },
        {
          path: "larval-site-details/:id",
          name: "data-larval-site-details",
          component: larvalSiteDetails,
          props: true,
          meta: {
            title: "Larval Site Master Details",
          },
        },
      ],
    },
    {
      path: "/lookup",
      name: "lookup",
      component: lookup,
      children: [
        {
          path: "achemicals",
          name: "lookup-achemicals",
          component: LookupAchemicals,
          meta: {
            title: "Lookup Achemcials",
          },
        },
        {
          path: "adultapprates",
          name: "lookup-adultapprates",
          component: LookupAdultAppRates,
          meta: {
            title: "Lookup Adult App Rates",
          },
        },
        {
          path: "aequips",
          name: "lookup-aequips",
          component: LookupAequips,
          meta: {
            title: "Lookup Aequips",
          },
        },
        {
          path: "applicators",
          name: "lookup-applicators",
          component: LookupApplicators,
          meta: {
            title: "Lookup Applicators",
          },
        },
        {
          path: "assays",
          name: "lookup-assays",
          component: LookupAssays,
          meta: {
            title: "Lookup Assays",
          },
        },
        {
          path: "contracts",
          name: "lookup-contracts",
          component: LookupContracts,
          meta: {
            title: "Lookup Contracts",
          },
        },
        {
          path: "contract-addresses",
          name: "lookup-contract-addresses",
          component: LookupContractAddresses,
          meta: {
            title: "Lookup Contract Addresses",
          },
        },
        {
          path: "control-actions",
          name: "lookup-control-actions",
          component: LookupControlActions,
          meta: {
            title: "Lookup Control Actions",
          },
        },
        {
          path: "counties",
          name: "lookup-counties",
          component: LookupCounties,
          meta: {
            title: "Lookup Counties",
          },
        },
        {
          path: "habitats",
          name: "lookup-habitats",
          component: LookupHabitats,
          meta: {
            title: "Lookup Habitats",
          },
        },
        {
          path: "larva-counts",
          name: "lookup-larva-counts",
          component: LookupLarvaCounts,
          meta: {
            title: "Lookup Larva Counts",
          },
        },
        {
          path: "larval-app-rates",
          name: "lookup-larval-app-rates",
          component: LookupLarvalAppRates,
          meta: {
            title: "Lookup Larval App Rates",
          },
        },
        {
          path: "lchemicals",
          name: "lookup-lchemicals",
          component: LookupLchemicals,
          meta: {
            title: "Lookup Lchemcials",
          },
        },
        {
          path: "lequipments",
          name: "lookup-lequipments",
          component: LookupLequipments,
          meta: {
            title: "Lookup Lequipments",
          },
        },
        {
          path: "mix-ratios",
          name: "lookup-mix-ratios",
          component: LookupMixRatios,
          meta: {
            title: "Lookup Mix Ratios",
          },
        },
        {
          path: "mosquito-species",
          name: "lookup-mosquito-species",
          component: LookupMosquitoSpecies,
          meta: {
            title: "Lookup Mosquito Species",
          },
        },
        {
          path: "municipalities",
          name: "lookup-municipalities",
          component: LookupMunicipalities,
          meta: {
            title: "Lookup Municipalities",
          },
        },
        {
          path: "request-types",
          name: "lookup-request-types",
          component: LookupRequestTypes,
          meta: {
            title: "Lookup Request Types",
          },
        },
        {
          path: "results",
          name: "lookup-results",
          component: LookupResults,
          meta: {
            title: "Lookup Results",
          },
        },
        {
          path: "routes_zones",
          name: "lookup-routes",
          component: LookupRoutes,
          meta: {
            title: "Lookup Routes",
          },
        },
        {
          path: "route_section_zones",
          name: "lookup-route-section-zones",
          component: LookupRouteSectionZones,
          meta: {
            title: "Lookup Route Section Zones",
          },
        },
        {
          path: "sra_options",
          name: "lookup-sra-options",
          component: LookupSraOptions,
          meta: {
            title: "Lookup Site Risk Assessment Options",
          },
        },
        {
          path: "states",
          name: "lookup-states",
          component: LookupStates,
          meta: {
            title: "Lookup States",
          },
        },
        {
          path: "subdivisions",
          name: "lookup-subdivisions",
          component: LookupSubdivisions,
          meta: {
            title: "Lookup Subdivisions",
          },
        },
        {
          path: "trap-nights",
          name: "lookup-trap-nights",
          component: LookupTrapNights,
          meta: {
            title: "Lookup Trap Nights",
          },
        },
        {
          path: "trap-teams",
          name: "lookup-trap-teams",
          component: LookupTrapTeams,
          meta: {
            title: "Lookup Trap Teams",
          },
        },
        {
          path: "trap-types",
          name: "lookup-trap-types",
          component: LookupTrapTypes,
          meta: {
            title: "Lookup Trap Types",
          },
        },
        {
          path: "trucks",
          name: "lookup-trucks",
          component: LookupTrucks,
          meta: {
            title: "Lookup Trucks",
          },
        },
        {
          path: "visual-monitors",
          name: "lookup-vizual-monitors",
          component: LookupVizualMonitors,
          meta: {
            title: "Lookup Visual Monitors",
          },
        },
        {
          path: "waters",
          name: "lookup-waters",
          component: LookupWaters,
          meta: {
            title: "Lookup Waters",
          },
        },
        {
          path: "wind-directions",
          name: "lookup-wind-directions",
          component: LookupWindDirections,
          meta: {
            title: "Lookup Wind Directions",
          },
        },
        {
          path: "zones",
          name: "lookup-zones",
          component: Zones,
          meta: {
            title: "Zones",
          },
        },
      ],
    },
    {
      path: "/report",
      name: "report",
      component: report,
      children: [
        {
          path: "adult-surveillance",
          name: "report-adult-surveillance",
          component: reportAdultSurveillance,
          meta: {
            title: "Adult Mosquito Surveillance Data",
          },
        },
        {
          path: "larval-surveillance",
          name: "report-larval-surveillance",
          component: reportLarvalSurveillance,
          meta: {
            title: "Larval Surveillance Report",
          },
        },
        {
          path: "report-larvicide-applications",
          name: "report-larvicide-applications",
          component: reportLarvicideApplications,
          meta: {
            title: "Larvicide Applications Report",
          },
        },
        {
          path: "report-arboviral-surveillance",
          name: "report-arboviral-surveillance",
          component: reportArboviralSurveillance,
          meta: {
            title: "Arboviral Surveillance Results",
          },
        },
        {
          path: "report-ot-surveillance",
          name: "report-ot-surveillance",
          component: reportOTSurveillance,
          meta: {
            title: "Mosquito Surveillance – Table Format",
          },
        },
        {
          path: "report-export-trap-dates",
          name: "report-export-trap-dates",
          component: reportExportTrapDates,
          meta: {
            title: "Trap Data Export",
          },
        },
        {
          path: "report-cmc-weekly-trap",
          name: "report-cmc-weekly-trap",
          component: reportCmcWeeklyTrap,
          meta: {
            title: "Trap Data - Details Report",
          },
        },
        {
          path: "report-cmc-trap-summary",
          name: "report-cmc-trap-summary",
          component: reportCmcTrapSummary,
          meta: {
            title: "Trap Data - Summary Report",
          },
        },
        {
          path: "report-ground-adulticide",
          name: "report-ground-adulticide",
          component: reportGroundAdulticide,
          meta: {
            title: "Ground Adulticide Applications",
          },
        },
        {
          path: "report-ot-weekly-program-summary",
          name: "report-ot-weekly-program-summary",
          component: reportOTWeeklyProgramSummary,
          meta: {
            title: "Weekly Program Summary",
          },
        },
        {
          path: "report-service-requests-summary",
          name: "report-service-requests-summary",
          component: reportServiceRequestsSummary,
          meta: {
            title: "Service Requests Summary",
          },
        },
        {
          path: "report-raw-export",
          name: "report-raw-export",
          component: reportRawExport,
          meta: {
            title: "Raw Export of ALL Data",
          },
        },
        {
          path: "report-boco-inspections",
          name: "report-boco-inspections",
          component: reportBocoInspections,
          meta: {
            title: "Basic Surveillance Data Export",
          },
        },
        {
          path: "report-route-book-sheets",
          name: "report-route-book-sheets",
          component: reportRouteBookSheets,
          meta: {
            title: "Site Route Book Sheets",
          },
        },
        {
          path: "report-kill-summary",
          name: "report-kill-summary",
          component: reportKillSummary,
          meta: {
            title: "Larval Site Data Summary",
          },
        },
        {
          path: "report-mcs-larvicide",
          name: "report-mcs-larvicide",
          component: reportMCSLarvicide,
          meta: {
            title: "Larvicide Report",
          },
        },
        {
          path: "report-boco-treatments",
          name: "report-boco-treatments",
          component: reportBocoTreatments,
          meta: {
            title: "CoB Larval Monitoring",
          },
        },
        {
          path: "report-denver-larvicide-dates",
          name: "report-denver-larvicide-dates",
          component: reportDenverLarvicideDates,
          meta: {
            title: "Larvicide Formatted Export",
          },
        },
        {
          path: "report-export-larvicide-dates",
          name: "report-export-larvicide-dates",
          component: reportExportLarvicideDates,
          meta: {
            title: "Larvicide Data Export",
          },
        },
        {
          path: "report-catch-basin",
          name: "report-catch-basin",
          component: reportCatchBasin,
          meta: {
            title: "Catch Basin Treatment Report",
          },
        },
        {
          path: "report-boulder-lab-submissions",
          name: "report-boulder-lab-submissions",
          component: reportBoulderLabSubmissions,
          meta: {
            title: "Arbovrial Lab Submissions Export",
          },
        },
        {
          path: "report-adult-sample-pool",
          name: "report-adult-sample-pool",
          component: reportAdultSamplePool,
          meta: {
            title: "Arbovrial Data Export",
          },
        },
        {
          path: "report-arbo-web-summary",
          name: "report-arbo-web-summary",
          component: reportArboWebSummary,
          meta: {
            title: "Arbo Web Summary",
          },
        },
        {
          path: "report-export-spray-dates",
          name: "report-export-spray-dates",
          component: reportExportSprayDates,
          meta: {
            title: "Adulticide Data Export",
          },
        },
        {
          path: "report-call-shutoff",
          name: "report-call-shutoff",
          component: reportCallShutoff,
          meta: {
            title: "Shutoffs/Notifications List",
          },
        },
        {
          path: "report-service-requests",
          name: "report-service-requests",
          component: reportServiceRequests,
          meta: {
            title: "Service Requests Report",
          },
        },
        {
          path: "report-landing-rate",
          name: "report-landing-rate",
          component: reportLandingRate,
          meta: {
            title: "Landing Rate Data",
          },
        },
        {
          path: "report-export-no-spray",
          name: "report-export-no-spray",
          component: reportExportNoSpray,
          meta: {
            title: "Shutoffs/Notifications Export",
          },
        },
        {
          path: "report-cmc-season-summary",
          name: "report-cmc-season-summary",
          component: reportCmcSeasonSummary,
          meta: {
            title: "All Traps - Composite Report",
          },
        },
        {
          path: "report-mosquito-surveillance-graph-1",
          name: "report-mosquito-surveillance-graph-1",
          component: reportMosquitoSurveillanceGraph1,
          meta: {
            title: "Surveillance Graph All Combined",
          },
        },
        {
          path: "report-mosquito-surveillance-graph-2",
          name: "report-mosquito-surveillance-graph-2",
          component: reportMosquitoSurveillanceGraph2,
          meta: {
            title: "Surveillance Graph with Species Breakdown",
          },
        },
        {
          path: "report-mcs-new-jersey-light-trap",
          name: "report-mcs-new-jersey-light-trap",
          component: reportMCSNewJerseyLightTrap,
          meta: {
            title: "New Jersey Light Trap Report",
          },
        },
        {
          path: "report-mcs-ovi-trap",
          name: "report-mcs-ovi-trap",
          component: reportMCSOviTrap,
          meta: {
            title: "Ovi Trap Report",
          },
        },
        {
          path: "report-mcs-gravid-trap",
          name: "report-mcs-gravid-trap",
          component: reportMCSGravidTrap,
          meta: {
            title: "Gravid Trap Report",
          },
        },
        {
          path: "report-gravid-highs",
          name: "report-gravid-highs",
          component: reportGravidHighs,
          meta: {
            title: "Gravid Highs Report",
          },
        },
        {
          path: "report-gravid-recap",
          name: "report-gravid-recap",
          component: reportGravidRecap,
          meta: {
            title: "Gravid Recap Report",
          },
        },
        {
          path: "report-mcs-light-female-trap",
          name: "report-mcs-light-female-trap",
          component: reportMCSLightFemaleTrap,
          meta: {
            title: "Light Trap Female Trap Report",
          },
        },
        {
          path: "report-ot-larval",
          name: "report-ot-larval",
          component: reportOtLarvalReport,
          meta: {
            title: "CoB Surveillance & Control Summary",
          },
        },
        {
          path: "report-export-hot-line",
          name: "report-export-hot-line",
          component: reportExportHotLine,
          meta: {
            title: "Export Hot Line",
          },
        },
        {
          path: "report-mcs-activity-recap",
          name: "report-mcs-activity-recap",
          component: reportMCSActivityRecap,
          meta: {
            title: "Activity Recap",
          },
        },
        {
          path: "report-spray-zone-recap",
          name: "report-spray-zone-recap",
          component: reportSprayZoneRecap,
          meta: {
            title: "Spray Zone Recap",
          },
        },
      ],
    },
    {
      // catch any 404 paths
      path: "*",
      redirect: "/",
    },
  ],
});

// authentication
router.beforeEach((to, from, next) => {
  if (typeof to.meta.title !== "undefined") {
    document.title = to.meta.title + " | VDCI";
  }

  if (to.meta.auth !== false) {
    return AuthService.isLoggedIn()
      .then(() => {
        next();
      })
      .catch(() => {
        next("/auth/login");
      });
  } else {
    next();
  }
});

export default router;
